import { graphql } from '../../../graphql/generated';

export const REQUEST_FOR_REORDER_QUERY = graphql(`
  query RequestForReorder($id: ID!) {
    request(id: $id) {
      id
      orders {
        id
        orderParameters {
          id
          shortName
          longName
          billingType
        }
        lab {
          id
          name
        }
      }
    }
  }
`);
